import { AfterViewChecked, AfterViewInit, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Gauge } from 'gaugeJS';
import { Subject } from 'rxjs';
import { Router } from '../../../../../../node_modules/@angular/router';
import { DashboardWidgetBase } from '../dashboard-widgets.base';
import { WidgetDataType } from '../widget-data-type';

declare let $: any;

export class GaugeData {
  public minVal: number;
  public maxVal: number;
  public value: number;
  public colour: string;
  public noDataMessage: string;
}

/* eslint max-classes-per-file: off */
@Component({
  selector: 'hb-gauge',
  templateUrl: 'gauge.component.html',
  styleUrls: ['gauge.component.scss'],
})
export class GaugeComponent extends DashboardWidgetBase implements OnInit, OnChanges, AfterViewInit, AfterViewChecked, OnDestroy {
  displayValue: string;

  brandPrimary = '#20a8d8';
  brandSuccess = '#4dbd74';
  brandInfo = '#63c2de';
  brandWarning = '#f8cb00';
  brandDanger = '#f86c6b';
  grayDark = '#4d4d4d';
  grayLighter = '#95adc3';

  tooltips = {
    [WidgetDataType.PlannedMaintenanceImprovements]:
      'Only displaying activities where Maintenance Activities have changed to less frequent activities',
  };

  @ViewChild('canvas') public canvasView: HTMLCanvasElement;


  private gaugeData: GaugeData;

  private gaugeOptions: any = {
    lines: 12,
    angle: -0.13,
    lineWidth: 0.25,
    pointer: {
      length: 0.6,
      strokeWidth: 0.035,
      color: this.grayDark,
    },
    limitMax: 'false',
    colorStart: this.brandInfo,
    colorStop: this.brandInfo,
    generateGradient: false,
    highDpiSupport: true,

    staticLabels: {
      font: '12px sans-serif', // Specifies font
      labels: [0, 0], // Print labels at these values
      color: '#003b70', // Optional: Label text color
      fractionDigits: 0, // Optional: Numerical precision. 0=round off.
    },
  };

  private unsub = new Subject();

  @Input() public colour: string;

  @Input() public data;

  private canvasObj: HTMLElement = null;
  constructor(route: Router, private changeDetector: ChangeDetectorRef) {
    super(route);
  }

  public ngOnChanges(changes: SimpleChanges){
    if((changes.colour || changes.data) && this.colour && this.data){
      this.initChartData();
    }
  }

  private initChartData(){
    const data = this.data;
    this.gaugeData = new GaugeData();
    this.gaugeData.maxVal = data.MaxVal;
    this.gaugeData.minVal = data.MinVal;
    this.gaugeData.value = data.Values.length;

    this.gaugeData.colour = this.colour;

    this.gaugeData.noDataMessage = data.NoDataMessage;
    this.drawGauge();
  }

  public drawGauge() {
    const target = this.canvasObj;

    if (!this.gaugeOptions || $.isEmptyObject(this.gaugeData) || !this.dashboardWidget.dashboardWidgetId || !target) {
      return;
    }

    this.gaugeOptions.staticLabels.labels[0] = this.gaugeData.minVal;
    this.gaugeOptions.staticLabels.labels[1] = this.gaugeData.maxVal;
    this.gaugeOptions.colorStart = this.gaugeData.colour;
    this.gaugeOptions.colorStop = this.gaugeData.colour;

    if (!target) {
      return;
    }

    const gauge = new Gauge(target).setOptions(this.gaugeOptions);

    gauge.minVal = this.gaugeData.minVal;
    gauge.maxValue = this.gaugeData.maxVal <= 0 ? 1 : this.gaugeData.maxVal;
    gauge.animationSpeed = 32;

    gauge.set(this.gaugeData.value);

    if (this.tooltips[this.dashboardWidget.widget.widgetDataType]) {
      target.title = this.tooltips[this.dashboardWidget.widget.widgetDataType];
    }

    this.displayValue = this.gaugeData.value.toString();
  }

  public ngAfterViewChecked(): void {
    this.changeDetector.detectChanges();
  }

  public ngAfterViewInit(): void {
    setTimeout(()=>{
      this.canvasObj = document.getElementById(this.canvasId);
      this.drawGauge();
    });
  }

  ngOnInit() {
    $(window).bind('resizeEnd', () => {
      this.drawGauge();
    });

    $(window).resize(function() {
      if (this.resizeTO) {
        clearTimeout(this.resizeTO);
      }

      this.resizeTO = setTimeout(function() {
        $(this).trigger('resizeEnd');
      }, 250);
    });
  }

  ngOnDestroy(): void {
    this.unsub.next(true);
    this.unsub.complete();
  }
}
